import { z } from 'zod'

export const paramsSchema = z.object({
  cottageId: z.string(),
  dateIn: z.string(),
  dateOut: z.string(),
  advance: z.number().int(),
  total: z.number().int(),
  conditionsId: z.string(),
  rentUnits: z.array(
    z.object({
      id: z.string(),
      people: z.number().int(),
      additional: z.number().int().nullable(),
      price: z.number().int(),
      extras: z.array(
        z.object({
          id: z.number().int(),
          units: z.number().int().nullable(),
          people: z.number().int().nullable(),
          days: z.number().int().nullable(),
          unitPrice: z.number().int(),
          totalPrice: z.number().int(),
        }),
      ),
    }),
  ),
})

export type paramsType = z.infer<typeof paramsSchema>
